import MobileSelect, { CascadeData } from 'mobile-select';
import React, { useRef, useState } from 'react';
import regions from './area.json';
interface Props {
  onChange: (v: string[]) => void;
}
export default function MCityPicker({ onChange }: Props) {
  const pickerRef = useRef<MobileSelect | null>(null);
  const [select, setSelect] = useState(false);

  function handleRef(v: any) {
    if (pickerRef.current) return;
    let data = regions;
    pickerRef.current = new MobileSelect({
      trigger: '#m-city-picker',
      title: '地址选择',
      wheels: [{ data }],
      keyMap: { id: 'value', value: 'label', childs: 'children' },
      onChange: (cur: any) => {
        if (!select) {
          setSelect(true);
        }
        onChange((cur as CascadeData[]).map((i) => (i as CascadeData).label));
      },
    });
  }
  return (
    <div id="m-city-picker" className={`m_city_picker ${select ? '' : 'place-holder'}`} ref={(v) => handleRef(v)}>
      请选择地区
    </div>
  );
}
